import React, { useState } from 'react';
import './TauriMultipleTagInput.css';  // Add any necessary styles

const TauriMultipleTagInput = ({ tags, setTags }) => {
    const [inputValue, setInputValue] = useState('');

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === 'Tab') {
            event.preventDefault();
            addTag(inputValue);
        } else if (event.key === 'Backspace' && !inputValue && tags.length > 0) {
            // Remove the last tag if input is empty and backspace is pressed
            setTags(tags.slice(0, -1));
        }
    };

    const addTag = (value) => {
        const trimmedValue = value.trim();
        if (trimmedValue && !tags.includes(trimmedValue)) {
            setTags([...tags, trimmedValue]);
            setInputValue('');
        }
    };

    const removeTag = (index) => {
        setTags(tags.filter((_, i) => i !== index));
    };

    return (
        <div className="tag-input-container">
            {tags.map((tag, index) => (
                <div key={index} className="tag">
                    {tag}
                    <img 
                        src={process.env.PUBLIC_URL + "/Images/carbon--close-outline.svg"} 
                        className='remove-tag' 
                        onClick={() => removeTag(index)} 
                        alt="remove tag" 
                    />
                </div>
            ))}
            <input
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
            />
        </div>
    );
};

export default TauriMultipleTagInput;
